/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/mv_max.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Converts a multivalued expression into a single valued column containing the maximum value.',
  examples: [
    'ROW a=[3, 5, 1]\n| EVAL max_a = MV_MAX(a)',
    'ROW a=["foo", "zoo", "bar"]\n| EVAL max_a = MV_MAX(a)',
  ],
  params: {
    field: 'Expression that can be null, a single value, or multiple values.',
  },
};

export default docs;
